export default "__VITE_ASSET__4cd4f587__"